import { render } from "./batteryStatusIcon.vue?vue&type=template&id=cdec67d0"
import script from "./batteryStatusIcon.vue?vue&type=script&lang=js"
export * from "./batteryStatusIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__